"use strict";

import Vue from 'vue';
import axios from "axios";
import store from "../store";
import {
  Message
} from 'element-ui';


// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// Vue.prototype.baseURL = "http://localhost:3000";

// Vue.prototype.baseURL = "http://192.168.0.72:3000";

Vue.prototype.baseURL = "http://testapi.bodensports.com";
// Vue.prototype.baseURL = "https://api.bodensports.com";


let config = {
  baseURL: Vue.prototype.baseURL
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    if (store.state.user.token) {
      config.headers.Authorization = store.state.user.token;
    }
    config.headers['BODONG_USER_UID'] = 1;
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    const res = response.data;
    if (res.resutlCode != "00000") {
      Message({
        message: res.msg || '网络异常，请稍后再试',
        type: 'error',
        duration: 2 * 1000
      })
    }
    return res;
  },
  function (error) {
    if (error.response.status == 401) {
      store.dispatch("user/resetToken");
    } else {
      Message({
        message: '网络异常，请稍后再试',
        type: 'error',
        duration: 2 * 1000
      })
    }

    return Promise.reject(error);
  }
);

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;